import React from 'react';
import { Outlet } from 'react-router-dom';

function Layout() {
  return (
    <div className="my-[0] mx-[auto] min-w-[1920px] max-w-[1920px] h-[1080px] max-h-[1080px] min-h-[1080px] flex flex-col justify-start items-start">
      <main className="relative w-full h-full flex flex-col overflow-hidden">
        <Outlet />
      </main>
    </div>
  );
}

export default Layout;
